<i18n src="./resources/locales.json"></i18n>

<template>
  <div id="agent_info_container">
    <v-menu v-model="profileMenuOpened" :close-on-content-click="false" bottom offset-y z-index="10000">
      <template v-slot:activator="{ on }">
        <!-- Main Display Component (Small Avatar) -->
        <div v-on="on">
          <EcsAvatar :agent-id="agent.id" :alt="agent.name" :size="32" stateful />
        </div>
      </template>
      <v-card id="agent_profile_card" color="surface lighten-1">
        <v-container class="card-layout">
          <section class="avatar">
            <v-hover id="agent-avatar" class="avatar-hover-bg">
              <v-avatar id="agent_profile_avatar" slot-scope="{ hover }" size="120">
                <EcsAvatar :agent-id="agent.id" :alt="agent.name" :size="120" no-animation />
                <v-expand-transition>
                  <div v-if="hover" class="transition-fast-in-fast-out v-card--reveal white--text">
                    <v-btn
                      class="profile-btn black darken-2"
                      color="white"
                      role="button"
                      :aria-label="$t('buttons.update')"
                      text
                      icon
                      small
                      @click="$refs.dialog.open()"
                    >
                      <v-row id="agentAvatarBtn" align="center" justify="center" no-gutters>
                        <v-col v-once>
                          {{ $t('buttons.update') }}<br />
                          <v-icon small>mdi-camera</v-icon>
                        </v-col>
                      </v-row>
                    </v-btn>
                  </div>
                </v-expand-transition>
              </v-avatar>
            </v-hover>
          </section>
          <section class="details">
            <div id="agent-full-name" class="xtium-title-regular">
              {{ trimmedAgentName }}
            </div>
            <div id="agent-phone-number">
              <v-icon class="mr-2" small> mdi-phone </v-icon>
              <span>{{ phoneNumber }}</span>
            </div>
            <div id="agent-chat-id">
              <v-icon class="mr-2" small> mdi-message-text </v-icon>
              <span>{{ agent.account }}</span>
            </div>
            <div id="agent-email-address">
              <v-icon class="mr-2" small> mdi-email </v-icon>
              <span>{{ agent.email }}</span>
            </div>
          </section>
        </v-container>
        <v-divider />
        <v-card-actions>
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-menu>

    <!-- Photo Update Dialog -->
    <EcsUpdateProfilePhotoDialog ref="dialog" @save-profile-photo="handleUpdateAvatar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EcsAvatar from '@/components/ecs-base-interaction-components/ecs-avatar/EcsAvatar';
import EcsUpdateProfilePhotoDialog from '@/components/ecs-agent-info/EcsUpdateProfilePhotoDialog';

export default {
  name: 'EcsAgentInfo',

  components: {
    EcsUpdateProfilePhotoDialog,
    EcsAvatar
  },

  data() {
    return {
      profileMenuOpened: false
    };
  },

  computed: {
    ...mapGetters('AGENT', ['loggedInAgent']),

    agent() {
      return this.loggedInAgent;
    },

    phoneNumber() {
      let displayName = '';

      if (this.agent.defaultPhone === 'HPBXPhone') {
        const addr = this.agent.hpbxExtension;
        displayName = addr.substr(0, addr.indexOf('@'));
      } else if (this.agent.defaultPhone === 'PrivatePhone') {
        if (this.agent.terminals && this.agent.terminals.length > 0) {
          const defaultPrivatePhone = this.agent.terminals.find(term => {
            return term.isDefault === true;
          });
          displayName = defaultPrivatePhone.uri;
        }
      } else {
        displayName = this.agent.endPoint;
      }

      return displayName;
    },

    trimmedAgentName() {
      return `${this.agent.name}`.trim();
    }
  },

  methods: {
    ...mapActions('AVATARS', ['upsertAvatar']),

    handleUpdateAvatar(avatar) {
      if (!avatar) {
        return;
      }

      if (this.agent.id === this.loggedInAgent.id) {
        this.upsertAvatar({ agentId: this.loggedInAgent.id, avatar });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.card-layout {
  display: grid;
  grid-template-columns: 132px auto;
  grid-column-gap: 8px;
  white-space: nowrap;
  padding: 24px 32px 24px 24px;

  .v-icon {
    margin-top: -2px;
  }

  div {
    line-height: 24px;

    span {
      opacity: 0.75;
    }
  }

  #agent-full-name {
    font-size: 22px;
    font-weight: 400;
    padding: 6px 0 14px 0;
  }
}

.profile-btn {
  font-size: 12px;
  text-transform: capitalize;
  border-radius: 0 0 50% 50%;
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 0.6;
}

.heading {
  font-size: x-large;
  text-align: left;
}

.v-card--reveal {
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  background-color: transparent !important;
}
</style>
